/**
 * @generated SignedSource<<e1657c61584d2fd3954468d764ad07a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChromeLogin_viewer$data = {
  readonly user: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "ChromeLogin_viewer";
};
export type ChromeLogin_viewer$key = {
  readonly " $data"?: ChromeLogin_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChromeLogin_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChromeLogin_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cd2f4f9e99d5580ac03fb5db15a4028f";

export default node;
